export const getLLMVisibilityClientName = (item) => {
  if (item?.cliente?.nome) {
    return item.cliente.nome
  }

  if (item?.brand) {
    return item.brand
  }

  return ''
}
